import * as ambassadorWixEcomV1ShippoConfiguration from './ecom-v1-shippo-configuration-shippo-configurations.http.js';
import * as ambassadorWixEcomV1ShippoConfigurationTypes from './ecom-v1-shippo-configuration-shippo-configurations.types.js';
import * as ambassadorWixEcomV1ShippoConfigurationUniversalTypes from './ecom-v1-shippo-configuration-shippo-configurations.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function createShippoConfiguration(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixEcomV1ShippoConfigurationUniversalTypes.CreateShippoConfigurationRequest,
  ambassadorWixEcomV1ShippoConfigurationTypes.CreateShippoConfigurationRequest,
  ambassadorWixEcomV1ShippoConfigurationUniversalTypes.CreateShippoConfigurationResponse,
  ambassadorWixEcomV1ShippoConfigurationTypes.CreateShippoConfigurationResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixEcomV1ShippoConfiguration.createShippoConfiguration(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/shippo-configurations',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getShippoConfiguration(): __PublicMethodMetaInfo<
  'GET',
  { shippoConfigurationId: string },
  ambassadorWixEcomV1ShippoConfigurationUniversalTypes.GetShippoConfigurationRequest,
  ambassadorWixEcomV1ShippoConfigurationTypes.GetShippoConfigurationRequest,
  ambassadorWixEcomV1ShippoConfigurationUniversalTypes.GetShippoConfigurationResponse,
  ambassadorWixEcomV1ShippoConfigurationTypes.GetShippoConfigurationResponse
> {
  const payload = { shippoConfigurationId: ':shippoConfigurationId' } as any;

  const getRequestOptions =
    ambassadorWixEcomV1ShippoConfiguration.getShippoConfiguration(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/shippo-configurations/{shippoConfigurationId}',
    pathParams: { shippoConfigurationId: 'shippoConfigurationId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function updateShippoConfiguration(): __PublicMethodMetaInfo<
  'PATCH',
  { shippoConfigurationId: string },
  ambassadorWixEcomV1ShippoConfigurationUniversalTypes.UpdateShippoConfigurationRequest,
  ambassadorWixEcomV1ShippoConfigurationTypes.UpdateShippoConfigurationRequest,
  ambassadorWixEcomV1ShippoConfigurationUniversalTypes.UpdateShippoConfigurationResponse,
  ambassadorWixEcomV1ShippoConfigurationTypes.UpdateShippoConfigurationResponse
> {
  const payload = {
    shippoConfiguration: { id: ':shippoConfigurationId' },
  } as any;

  const getRequestOptions =
    ambassadorWixEcomV1ShippoConfiguration.updateShippoConfiguration(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'PATCH',
    path: '/v1/shippo-configurations/{shippoConfiguration.id}',
    pathParams: { shippoConfigurationId: 'shippoConfigurationId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function deleteShippoConfiguration(): __PublicMethodMetaInfo<
  'DELETE',
  { shippoConfigurationId: string },
  ambassadorWixEcomV1ShippoConfigurationUniversalTypes.DeleteShippoConfigurationRequest,
  ambassadorWixEcomV1ShippoConfigurationTypes.DeleteShippoConfigurationRequest,
  ambassadorWixEcomV1ShippoConfigurationUniversalTypes.DeleteShippoConfigurationResponse,
  ambassadorWixEcomV1ShippoConfigurationTypes.DeleteShippoConfigurationResponse
> {
  const payload = { shippoConfigurationId: ':shippoConfigurationId' } as any;

  const getRequestOptions =
    ambassadorWixEcomV1ShippoConfiguration.deleteShippoConfiguration(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'DELETE',
    path: '/v1/shippo-configurations/{shippoConfigurationId}',
    pathParams: { shippoConfigurationId: 'shippoConfigurationId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function queryShippoConfigurations(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixEcomV1ShippoConfigurationUniversalTypes.QueryShippoConfigurationsRequest,
  ambassadorWixEcomV1ShippoConfigurationTypes.QueryShippoConfigurationsRequest,
  ambassadorWixEcomV1ShippoConfigurationUniversalTypes.QueryShippoConfigurationsResponse,
  ambassadorWixEcomV1ShippoConfigurationTypes.QueryShippoConfigurationsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixEcomV1ShippoConfiguration.queryShippoConfigurations(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/shippo-configurations/query',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function updateExtendedFields(): __PublicMethodMetaInfo<
  'POST',
  { id: string },
  ambassadorWixEcomV1ShippoConfigurationUniversalTypes.UpdateExtendedFieldsRequest,
  ambassadorWixEcomV1ShippoConfigurationTypes.UpdateExtendedFieldsRequest,
  ambassadorWixEcomV1ShippoConfigurationUniversalTypes.UpdateExtendedFieldsResponse,
  ambassadorWixEcomV1ShippoConfigurationTypes.UpdateExtendedFieldsResponse
> {
  const payload = { id: ':id' } as any;

  const getRequestOptions =
    ambassadorWixEcomV1ShippoConfiguration.updateExtendedFields(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/shippo-configurations/{id}/update-extended-fields',
    pathParams: { id: 'id' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function addDeliveryRegion(): __PublicMethodMetaInfo<
  'POST',
  { shippoConfigurationId: string },
  ambassadorWixEcomV1ShippoConfigurationUniversalTypes.AddDeliveryRegionRequest,
  ambassadorWixEcomV1ShippoConfigurationTypes.AddDeliveryRegionRequest,
  ambassadorWixEcomV1ShippoConfigurationUniversalTypes.AddDeliveryRegionResponse,
  ambassadorWixEcomV1ShippoConfigurationTypes.AddDeliveryRegionResponse
> {
  const payload = { shippoConfigurationId: ':shippoConfigurationId' } as any;

  const getRequestOptions =
    ambassadorWixEcomV1ShippoConfiguration.addDeliveryRegion(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/shippo-configurations/{shippoConfigurationId}/delivery-regions',
    pathParams: { shippoConfigurationId: 'shippoConfigurationId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function removeDeliveryRegion(): __PublicMethodMetaInfo<
  'DELETE',
  { shippoConfigurationId: string; deliveryRegionId: string },
  ambassadorWixEcomV1ShippoConfigurationUniversalTypes.RemoveDeliveryRegionRequest,
  ambassadorWixEcomV1ShippoConfigurationTypes.RemoveDeliveryRegionRequest,
  ambassadorWixEcomV1ShippoConfigurationUniversalTypes.RemoveDeliveryRegionResponse,
  ambassadorWixEcomV1ShippoConfigurationTypes.RemoveDeliveryRegionResponse
> {
  const payload = {
    shippoConfigurationId: ':shippoConfigurationId',
    deliveryRegionId: ':deliveryRegionId',
  } as any;

  const getRequestOptions =
    ambassadorWixEcomV1ShippoConfiguration.removeDeliveryRegion(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'DELETE',
    path: '/v1/shippo-configurations/{shippoConfigurationId}/delivery-regions/{deliveryRegionId}',
    pathParams: {
      shippoConfigurationId: 'shippoConfigurationId',
      deliveryRegionId: 'deliveryRegionId',
    },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  ShippoConfiguration as ShippoConfigurationOriginal,
  DomesticServiceSettings as DomesticServiceSettingsOriginal,
  DomesticService as DomesticServiceOriginal,
  DomesticServiceWithLiterals as DomesticServiceWithLiteralsOriginal,
  ServiceSettings as ServiceSettingsOriginal,
  HandlingFee as HandlingFeeOriginal,
  CalculationType as CalculationTypeOriginal,
  CalculationTypeWithLiterals as CalculationTypeWithLiteralsOriginal,
  InternationalServiceSettings as InternationalServiceSettingsOriginal,
  InternationalService as InternationalServiceOriginal,
  InternationalServiceWithLiterals as InternationalServiceWithLiteralsOriginal,
  PackageType as PackageTypeOriginal,
  PackageTypeWithLiterals as PackageTypeWithLiteralsOriginal,
  PackageDetails as PackageDetailsOriginal,
  PackageDimensions as PackageDimensionsOriginal,
  Address as AddressOriginal,
  StreetAddress as StreetAddressOriginal,
  AddressLocation as AddressLocationOriginal,
  ExtendedFields as ExtendedFieldsOriginal,
  CreateShippoConfigurationRequest as CreateShippoConfigurationRequestOriginal,
  CreateShippoConfigurationResponse as CreateShippoConfigurationResponseOriginal,
  GetShippoConfigurationRequest as GetShippoConfigurationRequestOriginal,
  GetShippoConfigurationResponse as GetShippoConfigurationResponseOriginal,
  UpdateShippoConfigurationRequest as UpdateShippoConfigurationRequestOriginal,
  UpdateShippoConfigurationResponse as UpdateShippoConfigurationResponseOriginal,
  DeleteShippoConfigurationRequest as DeleteShippoConfigurationRequestOriginal,
  DeleteShippoConfigurationResponse as DeleteShippoConfigurationResponseOriginal,
  QueryShippoConfigurationsRequest as QueryShippoConfigurationsRequestOriginal,
  CursorQuery as CursorQueryOriginal,
  CursorQueryPagingMethodOneOf as CursorQueryPagingMethodOneOfOriginal,
  Sorting as SortingOriginal,
  SortOrder as SortOrderOriginal,
  SortOrderWithLiterals as SortOrderWithLiteralsOriginal,
  CursorPaging as CursorPagingOriginal,
  QueryShippoConfigurationsResponse as QueryShippoConfigurationsResponseOriginal,
  CursorPagingMetadata as CursorPagingMetadataOriginal,
  Cursors as CursorsOriginal,
  UpdateExtendedFieldsRequest as UpdateExtendedFieldsRequestOriginal,
  UpdateExtendedFieldsResponse as UpdateExtendedFieldsResponseOriginal,
  DomainEvent as DomainEventOriginal,
  DomainEventBodyOneOf as DomainEventBodyOneOfOriginal,
  EntityCreatedEvent as EntityCreatedEventOriginal,
  RestoreInfo as RestoreInfoOriginal,
  EntityUpdatedEvent as EntityUpdatedEventOriginal,
  EntityDeletedEvent as EntityDeletedEventOriginal,
  ActionEvent as ActionEventOriginal,
  Empty as EmptyOriginal,
  AddDeliveryRegionRequest as AddDeliveryRegionRequestOriginal,
  AddDeliveryRegionResponse as AddDeliveryRegionResponseOriginal,
  RemoveDeliveryRegionRequest as RemoveDeliveryRegionRequestOriginal,
  RemoveDeliveryRegionResponse as RemoveDeliveryRegionResponseOriginal,
  MessageEnvelope as MessageEnvelopeOriginal,
  IdentificationData as IdentificationDataOriginal,
  IdentificationDataIdOneOf as IdentificationDataIdOneOfOriginal,
  WebhookIdentityType as WebhookIdentityTypeOriginal,
  WebhookIdentityTypeWithLiterals as WebhookIdentityTypeWithLiteralsOriginal,
  AccountInfo as AccountInfoOriginal,
} from './ecom-v1-shippo-configuration-shippo-configurations.types.js';
